import React, { useEffect, useState } from 'react';
import { Table, Button } from 'antd';
import { isEffectArray } from '@/common/utils';
import Dongdong from '@/components/dongdong';
import IconTip from '@/components/icon-tip';
import ShowMorePopList from '@/components/show-more-pop-list';
import ComponentLog from '@/components/component-log';
import CrossDetailModal from './../cross-detail-modal';
import { SORTFIELDENUM, SORTORDERENUM } from './../../config';
import { logCateDetail } from '../../log';

/* *********
 * 展示内容table
 ********* */
// 默认分页器参数
const initPaginations = {
  defaultCurrent: 1,
  current: 1,
  pageSize: 10,
  total: 0,
};

const CrossContentTable = (props) => {
  const { tableData, operationCallback } = props;
  const [pagination, setPagination] = useState(initPaginations);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentRowItem, setCurrentRowItem] = useState({});

  useEffect(() => {
    if (tableData) {
      setPagination((pre) => ({
        ...pre,
        total: tableData?.totalCount || 0,
        current: tableData?.currentPage || 1,
      }));
    }
  }, [tableData]);
  /**********************************************
   * ****************** 构建列 ******************
   ***********************************************/
  /* commonClumns */
  const commonClumns = [
    {
      title: '排序',
      dataIndex: 'serialNo',
      key: 'serialNo',
      width: 80,
      align: 'center',
    },
    {
      title: '推荐品类',
      dataIndex: 'recCidName',
      key: 'recCidName',
      ellipsis: true,
      render: (value, { recCidName }) => {
        return <>{recCidName || '-'}</>;
      },
    },
    {
      title: (
        <>
          <span className="title-component-txt" style={{ marginRight: '5px' }}>
            综合推荐分
            <IconTip
              placement="top"
              title="指标解释：综合考虑品类关联度和品类渗透空间的推荐品类得分。该指标会同时考虑品类之间关联性强弱（是否更易形成共同销售转化），以及品类之间是否有更大的空间可以通过跨品类活动来提升自身品类在关联品类内的用户数。"
            />
          </span>
        </>
      ),
      dataIndex: 'promScorePer',
      key: 'promScorePer',
      sorter: true,
    },
    {
      title: (
        <>
          <span className="title-component-txt" style={{ marginRight: '5px' }}>
            品类关联度评分
            <IconTip
              placement="top"
              title="指标解释：两个品类共购用户在所有用户中的比例，占比越高则关联度越高。例如：在购买洗发水或购买护发素的用户中，同时购买洗发水和购买护发素的用户越多，则洗发水和护发素关联性越强。"
            />
          </span>
        </>
      ),
      dataIndex: 'refScorePer',
      key: 'refScorePer',
      sorter: true,
    },
    {
      title: (
        <>
          <span className="title-component-txt" style={{ marginRight: '5px' }}>
            品类渗透空间评分
            <IconTip
              placement="top"
              title="指标解释：品类间渗透率越低，品类之间合作机会和可渗透空间越多，即品类渗透空间（得分）越高。品类渗透率指关联品类B中购买A品类的用户占比。例如：食品饮料在家用电器中的渗透率=（食品饮料和家用电器的重合用户）/家用电器用户。"
            />
          </span>
        </>
      ),
      dataIndex: 'permScorePer',
      key: 'permScorePer',
      sorter: true,
    },
    {
      title: (
        <>
          <span className="title-component-txt" style={{ marginRight: '5px' }}>
            品类对接人
            <IconTip placement="top" title="负责跨品类合作对接" />
          </span>
        </>
      ),
      dataIndex: 'authorInfos',
      key: 'authorInfos',
      render: (value, item) => {
        if (!isEffectArray(value)) {
          return '-';
        } else {
          let sourceList = [];
          isEffectArray(value)
            ? value.forEach((item, index) => {
                sourceList.push({
                  txt: (
                    <ComponentLog key={index}>
                      <div clstag="yx_center_kplyx_1668603027997|4">
                        <Dongdong name={item?.realName} erp={item?.erp} />
                      </div>
                    </ComponentLog>
                  ),
                });
              })
            : [];
          return <ShowMorePopList sourceList={sourceList} maxShowNum={3} />;
        }
      },
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      align: 'center',
      width: 200,
      render: (value, item) => {
        return (
          <div onClick={logCateDetail} className="buttons-fa">
            <Button
              type="link"
              onClick={() => operateActionBtn(item)}
              className="buttons-item"
              style={{ paddingLeft: 0, paddingRight: 0, border: 0, marginLeft: 16 }}
            >
              {`查看详情`}
            </Button>
          </div>
        );
      },
    },
  ];

  /**********************************************
   * ****************** 业务操作 ******************
   ***********************************************/
  /* 操作-弹窗 */
  function operateActionBtn(item) {
    setCurrentRowItem(item);
    setModalVisible(true);
  }

  /* 分页器变化 */
  function onPaginationChange(page, pageSize) {
    setPagination((pre) => ({ ...pre, current: page }));
  }

  /* 排序 */
  function onTableChange(pagination, filters, sorter, { action }) {
    if (action === 'sort') {
      const sorterColumnKey = sorter.columnKey;
      const sorterOrder = sorter.order;
      //互斥
      switch (sorterColumnKey) {
        case SORTFIELDENUM['REF'].frontKey:
          setPagination(initPaginations);
          operationCallback(
            'SORTERORDERCHANGE',
            sorterOrder === 'ascend'
              ? {
                  sortField: SORTFIELDENUM['REF'].key,
                  sortOrder: SORTORDERENUM['1'].key,
                }
              : sorterOrder === 'descend'
              ? {
                  sortField: SORTFIELDENUM['REF'].key,
                  sortOrder: SORTORDERENUM['2'].key,
                }
              : {}
          );
          break;
        case SORTFIELDENUM['PERM'].frontKey:
          operationCallback(
            'SORTERORDERCHANGE',
            sorterOrder === 'ascend'
              ? {
                  sortField: SORTFIELDENUM['PERM'].key,
                  sortOrder: SORTORDERENUM['1'].key,
                }
              : sorterOrder === 'descend'
              ? {
                  sortField: SORTFIELDENUM['PERM'].key,
                  sortOrder: SORTORDERENUM['2'].key,
                }
              : {}
          );
          setPagination(initPaginations);
          break;
        case SORTFIELDENUM['PROM'].frontKey:
          operationCallback(
            'SORTERORDERCHANGE',
            sorterOrder === 'ascend'
              ? {
                  sortField: SORTFIELDENUM['PROM'].key,
                  sortOrder: SORTORDERENUM['1'].key,
                }
              : sorterOrder === 'descend'
              ? {
                  sortField: SORTFIELDENUM['PROM'].key,
                  sortOrder: SORTORDERENUM['2'].key,
                }
              : {}
          );
          setPagination(initPaginations);
          break;
        default:
          break;
      }
    }
  }

  return (
    <div className="join-venue-room-table-fa">
      <Table
        scroll={{ x: 1200 }}
        columns={commonClumns}
        rowKey={({ serialNo }) => `${serialNo}`}
        dataSource={tableData?.list}
        onChange={onTableChange}
        pagination={{
          ...pagination,
          total: pagination.total,
          showSizeChanger: false,
          showTotal: (total) => `总共${total}条`,
          onChange: onPaginationChange,
        }}
      />

      {/* 看板详情弹窗 */}
      <CrossDetailModal modalVisible={modalVisible} setModalVisible={setModalVisible} currentRowItem={currentRowItem} />
    </div>
  );
};

export default CrossContentTable;
